import { RingPositions } from "shared/constants/ringPositionType"

export enum DafesProjectType {
    default = 0,
    art = 1
}

interface CompetitionCardModalProps {
    isModalCard?: boolean;
    isSelected?: boolean;
    isAlready?: boolean;
    selectRingPosition?: RingPositions;
    onSelect?: (projectId: string) => void;
}

export interface CompetitionCardProps extends CompetitionCardModalProps {
    competitionProps: any;
    isNewType: boolean;
    isProfile?: boolean;
    isMainPage?: boolean;
    currentTagId?: string;
    addParams?: { sorting: number };
}

export interface OptionProps {
    name: string;
    identifier: number;
}import { RingPositions } from "shared/constants/ringPositionType"

export enum DafesProjectType {
    default = 0,
    art = 1
}

interface CompetitionCardModalProps {
    isModalCard?: boolean;
    isSelected?: boolean;
    isAlready?: boolean;
    selectRingPosition?: RingPositions;
    onSelect?: (projectId: string) => void;
}

export interface CompetitionCardProps extends CompetitionCardModalProps {
    competitionProps: any;
    isNewType: boolean;
    isProfile?: boolean;
    isMainPage?: boolean;
    currentTagId?: string;
    addParams?: { sorting: number };
}

export interface OptionProps {
    name: string;
    identifier: number;
}